class Modal {
    constructor( settings ) {
        this.settings = settings

        this.init()
    }

    init () {
        this.bindEvents()
    }

    bindEvents () {
        const source = this.settings.source
        source.on( "click", this.showModal.bind( this ) )
        $( "body" ).on( "click", ".close", this.closeModal.bind( this ) )
    }

    showModal ( e ) {
        e.preventDefault()
        const TARGET = this.settings.target

        $( TARGET ).addClass( "active" )

    }

    closeModal ( e ) {
        e.preventDefault()
        const TARGET = this.settings.target

        TARGET.closest( ".modal" ).removeClass( "active" ).find( "[id^=carousel_]" ).slick( "unslick" )
    }
}

new Modal( {
    source: $( "a[href='#providers_modal']" ),
    target: $( '#_modal_providers' )
} )


new Modal( {
    source: $( "a[href='#quotes_modal']" ),
    target: $( '#_modal_quotes' )
} )
